export const enum ComposeEditorType {
    Textarea = 1,
    RoosterHTML = 2,
    RawContentEditableDivHTML = 3,
}
